import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../api/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const updateUser = async ({ userId, name, role_ids = [] }) => {
  const { data } = await authApiClient.put(`/users/${userId}`, { name, role_ids });
  return data;
};

export const useUpdateUserHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: 'User updated successfully',
          severity: 'success',
        }),
      );
      onSuccess?.();
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError ? error.response?.data?.errors?.message || error.message : 'Failed to update user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
